import standardEventTypes from '../eventTypes';

const standardActions = new Set(standardEventTypes.map((eventType) => eventType.value));

// The domain's observed event actions minus the standard ones - the same definition of
// "custom event" the rest of the app uses (helpers/useEventTypes, the Facebook tracking
// and Analytics settings tabs). Catalog trigger events are kept: they are emitted per
// profile like any other event, so segmenting on them is meaningful.
export const customEventActions = (eventActions) =>
  [...new Set(eventActions || [])]
    .filter((action) => action && !standardActions.has(action))
    .sort((a, b) => a.localeCompare(b));

// Replaces the generic "Performed custom action" rule with one ready-made rule per custom
// event the domain emits. The generic rule left the action unset: it matched nothing until
// the user added the "Action name" filter and picked from it, which is the step this
// removes. It is dropped from the offered list rather than kept alongside the generated
// rules - an event the domain has never emitted was never selectable in that filter
// either, and several actions in one rule is what the nested "At least one of..." rule is
// for.
const expandCustomActionRules = (availableRules, eventActions) => {
  const templateIndex = availableRules.findIndex((rule) => rule.key === 'customAction');

  // Every other rule set (profile filter, catalog, Facebook, Google) has no such rule.
  if (templateIndex === -1) {
    return availableRules;
  }

  const template = availableRules[templateIndex];
  const generated = customEventActions(eventActions).map((eventAction) => {
    // The action is pinned by the condition below, so offering the filter that sets it
    // would only let the user contradict it.
    const availableFilters = { ...template.availableFilters };
    delete availableFilters.action;

    return {
      // Spread rather than picked field by field, so anything added to the template later
      // reaches the generated rules too. Its `key` comes along with it, which is what
      // keeps their icon and leaves a rule saved back when the generic rule was offered
      // directly indistinguishable from a generated one.
      ...template,
      name: `Performed action: ${eventAction}`,
      conditions: [{ field: 'action', conditionType: 'term', values: [eventAction] }],
      availableFilters,
    };
  });

  return [...availableRules.slice(0, templateIndex), ...generated, ...availableRules.slice(templateIndex + 1)];
};

export default expandCustomActionRules;
